import { render, staticRenderFns } from "./CaseCreationOrderForm.vue?vue&type=template&id=7cfc0b99&scoped=true&"
import script from "./CaseCreationOrderForm.vue?vue&type=script&lang=js&"
export * from "./CaseCreationOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseCreationOrderForm.vue?vue&type=style&index=0&id=7cfc0b99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfc0b99",
  null
  
)

component.options.__file = "CaseCreationOrderForm.vue"
export default component.exports